import { render, staticRenderFns } from "./ConfigQuestionEdit.vue?vue&type=template&id=d882f788"
import script from "./ConfigQuestionEdit.vue?vue&type=script&lang=js"
export * from "./ConfigQuestionEdit.vue?vue&type=script&lang=js"
import style0 from "./ConfigQuestionEdit.vue?vue&type=style&index=0&id=d882f788&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports